// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Decco from "decco/src/Decco.bs.mjs";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_json from "rescript/lib/es6/js_json.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as IdFunctor$FeedSync from "../IdFunctor.bs.mjs";

var Id = IdFunctor$FeedSync.Make({});

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "id",
                Curry._1(Id.t_encode, v.id)
              ],
              [
                "active",
                Decco.boolToJson(v.active)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Curry._1(Id.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var active = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "active"), null));
    if (active.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                id: id._0,
                active: active._0
              }
            };
    }
    var e = active._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".active" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function t_encode$1(v) {
  return Decco.arrayToJson(t_encode, v);
}

function t_decode$1(v) {
  return Decco.arrayFromJson(t_decode, v);
}

var $$Array = {
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

export {
  Id ,
  t_encode ,
  t_decode ,
  $$Array ,
}
/* Id Not a pure module */
